import { arrayOf, Schema } from 'normalizr';


export const CUSTOM_TAG_SCHEMA = new Schema('customTags');

export const CUSTOM_TAGS_SCHEMA = arrayOf(CUSTOM_TAG_SCHEMA);
